export default [
  {
    path: '/TTincident',
    name: 'TTincident',
    component: () => import('../../components/TTincident.vue'),
  },
  {
    path: '/FBincident',
    name: 'FBincident',
    component: () => import('../../components/FBincident.vue'),
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('../../components/404.vue'),
  },
];
